export default {
    namespaced: true,

    state: {
        env: []
    },

    getters: {
        getEnv (state) {
            return state.env
        }
    },

    mutations: {
        SET_ENV (state, value) {
            state.env = value
        }
    },

    actions: {
        setEnv({commit}, data) {
            commit('SET_ENV', data)
        }
    }
}
